import styled, { css } from 'styled-components';

import Picture from 'components/picture';
import BlockRenderer from 'components/sanity-block-renderer';

export const descriptionStyles = css`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.75rem;
  color: ${Styles.color.black};
  text-align: left;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
`;

export const Description = styled.div`
  ${descriptionStyles}
`;

export const DescriptionBlockRenderer = styled(BlockRenderer)`
  ${descriptionStyles}
`;

export const ImageContainer = styled.div`
  border-radius: ${Styles.borderRadius};
  width: 100%;
  height: 135px;
  background-position: center 42%;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;

  ${Styles.desktop`
    height: 195px;
  `}
`;

export const InfoContainer = styled.div`
  margin-top: 1rem;

  ${Styles.desktop`
    margin-top: 2rem;
  `}
`;

export const TileCarouselSectionContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  ${Styles.desktop`
    max-width: 1400px;
    padding: 0;
  `}
`;

export const TilesList = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  ${Styles.mobile`
    margin: 0 auto;
  `}
`;

export const TileContainer = styled.div`
  display: flex;
  width: 16.5rem;
  height: 16rem;
  background-color: ${Styles.color.white};
  color: ${Styles.color.black};
  flex-direction: column;
  border-radius: 8px;
  cursor: pointer;
  margin-right: 24px;
  padding: 16px;

  ${Styles.desktop`
    width: 22rem;
    height: 21rem;
  `}
`;

export const TileImg = styled(Picture)``;

export const Title = styled.div`
  font-size: 1rem;
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.heavy}
  color: ${Styles.color.black};
  text-align: left;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;

  ${Styles.desktop`
    font-size: 1.15rem;
  `}
`;
